import { render, staticRenderFns } from "./PostsBootstrap.vue?vue&type=template&id=a81bee92&scoped=true&"
import script from "./PostsBootstrap.vue?vue&type=script&lang=js&"
export * from "./PostsBootstrap.vue?vue&type=script&lang=js&"
import style0 from "./PostsBootstrap.vue?vue&type=style&index=0&id=a81bee92&lang=scss&scoped=true&"
import style1 from "./PostsBootstrap.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81bee92",
  null
  
)

export default component.exports